import Vue from "vue";
import DatePicker from "vue2-datepicker";
import SortedTablePlugin from "vue-sorted-table";
import Paginate from "@/components/widgets/pagination.vue";
import moment from "moment";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>',
});
export default {
  components: {
    DatePicker,
    Paginate,
  },
  data: function () {
    return {
      role: "",
      branch: "",
      keyword: null,
      keyword_startdate: null,
      keyword_enddate: null,
      busy: false,
      totalItem: 0,
      currentPage: 1,
      currentData: {},
      apiStatus: "ไม่พบข้อมูล",
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "document_no",
          label: "เลขที่เอกสาร",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "customer_detail",
          label: "ลูกค้า",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "reason",
          label: "เหตุผลการลดหนี้",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "remark",
          label: "หมายเหตุ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "grand_total",
          label: "ยอดลดหนี้ (รวม VAT)",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
          class: "text-right",
        },
        {
          key: "creator_detail.name",
          label: "ผุ้จัดทำ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
          class: "text-right",
        },
        {
          key: "action",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          class: "text-right",
        },
      ],
      items: [],
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    this.getRole();
    this.onInitData(this.currentPage);
  },
  methods: {
    async getRole() {
      const res = await this.$store.dispatch('Auth/getRole', {}, { root: true });
      this.role = res.data.role;
      this.branch = res.data.branch_id;
    },
    oncreate() {
      this.$router.push("/tax/credit-tax-create");
    },
    async onInitData(currentPage) {
      this.currentPage = currentPage;
      try {
        this.busy = true;
        this.apiStatus = "กำลังค้นหาข้อมูล..";

        const page = currentPage ? currentPage : 1;
        const url = `${Vue.prototype.$host}/api/v1/document/credit-note-tax?page=${page}&keyword=${this.keyword || ''}&keyword_startdate=${this.keyword_startdate ? moment(this.keyword_startdate).format('YYYY-MM-DD') : ''}&keyword_enddate=${this.keyword_enddate ? moment(this.keyword_enddate).format('YYYY-MM-DD') : ''}`;
        const result = await Vue.prototype.$axios.get(url);

        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";

        if (result) {
          this.currentData = result.data;
          this.items = result.data.data || [];
          this.totalItem = result.data.total;
        } else {
          this.items = [];
          this.totalItem = 0;
        }
      } catch (error) {
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    onedit(uuid) {
      this.$router.push("/tax/credit-tax-create/" + uuid);
    },
    generatePDF(uuid) {
      try {
        this.loading = true;
        setTimeout(async () => {
          const result = await this.$axios.get(
            this.$host + "/api/v1/document/credit-note-tax/" + uuid + "/pdf",
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              responseType: "blob"
            }
          );
          const blob = new Blob([result.data], { type: 'application/pdf' });
          const objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl, 'targetWindow',
          `toolbar=no,
          location=no,
          status=no,
          menubar=no,
          scrollbars=yes,
          resizable=yes,
          width=SomeSize,
          height=SomeSize`);
          this.loading = false;
        }, 1000);
      } catch (error) {
        this.loading = false;
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
  },
};
